
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Categoria } from 'src/app/model/categoria';
import { DetalleCambioDTO } from 'src/app/model/detalleCambioDTO';
import { PedidoOutErpCambiado } from 'src/app/model/pedidoOutErpCambiado';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class CambioService {
    private url : string = `${environment.HOST}/api/cambio`;
    private urlUpload : string = `${environment.HOST}/api`;

    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   

      nuevoCambio( idCliente : number, idDepto : Number,idMuni : Number,total : number,nombreRecibe : String,direccionEntrega :String,telefono:String,motivo:String,idFormaPago:number,detalleCompra:String,numeroTarjeta:string,vencimiento:string,codigoSeguridad:string,nit:string,nombreFactura:string,direccionFactura:string) {
        return this.http.post(`${this.url}/nuevo-cambio/${idCliente}/${idDepto}/${idMuni}/${total}/${nombreRecibe}/${direccionEntrega}/${telefono}/${motivo}/${idFormaPago}/${detalleCompra}/${numeroTarjeta}/${vencimiento}/${codigoSeguridad}/${nit}/${nombreFactura}/${direccionFactura}`, "");
      }
    

      aplicaCambio( idCambio : number, idUsuario:number,codigoErpNuevo:number,idSucursal:number,observacion:String,colorErp:String,colorIdErp:number) {
        return this.http.post(`${this.url}/aplica-cambio/${idCambio}/${idUsuario}/${codigoErpNuevo}/${idSucursal}/${observacion}/${colorErp}/${colorIdErp}`, "");
      }
      
      getDetalleCambioByIndiceDetallePedido(indiceDetallePedido:number,idPedido:number):Observable<DetalleCambioDTO[]>{
        return this.http.get<DetalleCambioDTO[]>(`${this.url}/detalle-by-indice-detalle-pedido/${indiceDetallePedido}/${idPedido}`);
      }
      
      getPedidoOutErpCambiado(pedidoId:number):Observable<PedidoOutErpCambiado[]>{
        return this.http.get<PedidoOutErpCambiado[]>(`${this.url}/pedido-out-erp-cambiado/${pedidoId}`);
      }
      


    }